@if(!searchResponse){
  <div class='load-page-spinner'>
    <h3>Your dashboard is loading</h3><mat-spinner class="spinner" diameter="30"></mat-spinner>
  </div>
}@else{
  <div class="dashboard-container">
    <div class="flex-header">
      <h2 class="header-text">{{headerText}}</h2>
    </div>
    <div class="data-cards-container">
      @for(card of dataCardNameArray; track card){
        <div class="data-card">
          <app-data-display-card
            [dataValue]="statusCounts[card]"
            [theme]="dataCardConfigs[card]?.theme"
            [cardTitle]="dataCardConfigs[card]?.cardTitle"
            [cardIcon]="dataCardConfigs[card]?.cardIcon">
          </app-data-display-card>
        </div>
      }
    </div>
    <div class="review-grid">
      <!-- UNIVERSAL FILTER RESETTER -->
      <div class="button-container">
        @if(bulkSubmitInProgress){
          <div class="submit-spinner-container">
            <mat-spinner class="submit-spinner" [diameter]="20"></mat-spinner>
          </div>
        }@else{
          <button mat-raised-button color="primary" (click)="bulkSubmitApps()" [disabled]="dynamicDisableBulkSubmit" class="bulk-submit-button">Bulk Submit Selected</button>
        }
        @if (showResetFiltersButton) {
          <button mat-raised-button color="secondary" (click)="resetFilters()" class="reset-filter-button">Reset Filters</button>
        }
      </div>
      
      <app-sep-application-review-grid
        [rowData]="allAppRowData"
        [searchAppServiceResponse]="allApps" 
        (statusChanged)="onStatusChange($event)"
        (selectedRows)="onSelectionChange($event)">
      </app-sep-application-review-grid> <!-- does this var actually work as intended? now it does -->
    </div>
  </div>
}
